/* Vitalia · base interactions — scroll reveal, counters, timeline */
(function(){
  if (window.__vitaliaInit) return;
  window.__vitaliaInit = true;

  function initReveal(){
    var els = document.querySelectorAll('.vt-reveal, .vt-reveal-up, .vt-reveal-left, .vt-reveal-right, .vt-reveal-scale, .vt-stagger');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(e){ e.classList.add('vt-in'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('vt-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold:.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  function animateCounter(el, duration){
    duration = duration || 2000;
    var target = +el.dataset.target;
    var start = null;
    var easeOut = function(t){ return 1 - Math.pow(1-t, 3); };
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts - start)/duration, 1);
      el.textContent = Math.round(target * easeOut(p));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target;
    }
    requestAnimationFrame(step);
  }

  function initCounters(){
    if (!('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function(entries, o){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.querySelectorAll('.vt-counter, .vt-bp-counter').forEach(function(c){ animateCounter(c); });
          o.unobserve(e.target);
        }
      });
    }, { threshold:.3 });
    document.querySelectorAll('[data-vt-counter-host]').forEach(function(s){ obs.observe(s); });
  }

  function initTimeline(){
    var items = document.querySelectorAll('.vt-tl-item');
    items.forEach(function(item, i){ if (i < 2) item.classList.add('vt-active'); });
    if (!('IntersectionObserver' in window)) {
      items.forEach(function(item){ item.classList.add('vt-active'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) e.target.classList.add('vt-active'); });
    }, { threshold:.55, rootMargin:'0px 0px -100px 0px' });
    items.forEach(function(item){ obs.observe(item); });
  }

  function initFlip(){
    document.querySelectorAll('.vt-flip-card').forEach(function(card){
      card.addEventListener('click', function(){ card.classList.toggle('vt-active'); });
    });
  }

  function initTabs(){
    document.querySelectorAll('[data-vt-tabs]').forEach(function(scope){
      scope.querySelectorAll('.vt-tab').forEach(function(tab){
        tab.addEventListener('click', function(){
          var i = tab.dataset.tab;
          scope.querySelectorAll('.vt-tab').forEach(function(t){ t.classList.remove('vt-active'); });
          scope.querySelectorAll('.vt-panel').forEach(function(p){ p.classList.remove('vt-active'); });
          tab.classList.add('vt-active');
          var panel = scope.querySelector('.vt-panel[data-panel="' + i + '"]');
          if (panel) panel.classList.add('vt-active');
        });
      });
    });
  }

  function init(){
    initReveal();
    initCounters();
    initTimeline();
    initFlip();
    initTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on theme editor section reload
  document.addEventListener('shopify:section:load', init);
})();
